import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, initInstallPrompt } from "@/lib/serviceWorker";

// Register PWA Service Worker
registerServiceWorker();
initInstallPrompt();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
